import React from 'react';
import { Row, Col } from 'antd';
import {
  CheckCircleOutlined,
  BulbOutlined,
  SolutionOutlined,
} from '@ant-design/icons';
import { DashboardSectionCard } from '../../components/Dashboard/DashboardSectionCard';
type Props = {
  onAnalyzeDeal: (dealId: string, dealName?: string) => void;
  onNavigateSituationNew: () => void;
  onNavigateSolutionNew: () => void;
};

export function MarketFitDashboardNavCards({
  onAnalyzeDeal,
  onNavigateSituationNew,
  onNavigateSolutionNew,
}: Props) {
  return (
    <Row gutter={[24, 24]}>
      <Col xs={24} sm={8}>
        <DashboardSectionCard
          title="Deals"
          icon={<CheckCircleOutlined />}
          description="View and manage all deals"
          onClick={() => onAnalyzeDeal('demo-deal-1', 'Demo Deal')}
          metrics={[{ label: 'Total', value: '—' }]}
        />
      </Col>
      <Col xs={24} sm={8}>
        <DashboardSectionCard
          title="Situations"
          icon={<BulbOutlined />}
          description="Customer situations and use cases"
          onClick={onNavigateSituationNew}
          metrics={[{ label: 'Defined', value: '—' }]}
        />
      </Col>
      <Col xs={24} sm={8}>
        <DashboardSectionCard
          title="Solutions"
          icon={<SolutionOutlined />}
          description="Product solutions and fit scores"
          onClick={onNavigateSolutionNew}
          metrics={[{ label: 'Available', value: '—' }]}
        />
      </Col>
    </Row>
  );
}
